import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedConditions: getSavedState('device.conditions'),
  selectedCondition: null,
}

export const getters = {
  cachedConditions(state) {
    return state.cachedConditions
  },
  selectedCondition(state) {
    return state.selectedCondition
  },
}

export const mutations = {
  SET_CACHE(state, conditions) {
    state.cachedConditions = conditions
    saveState('device.conditions', conditions)
  },
  SET_SELECTED(state, condition) {
    state.selectedCondition = condition
  },
}

export const actions = {
  selectCondition({ commit, state, rootState }, { condition }) {
    commit('SET_SELECTED', condition)
  },

  fetchConditions({ commit, state, rootState }, { clearCache, deviceId, dateRange }) {
    // 1. Check if we've already fetched and cachedGroups the condition groups.
    const matchedConditions = state.cachedConditions

    if (!clearCache && matchedConditions) {
      return Promise.resolve(matchedConditions)
    }
    let url

    if (dateRange) {
      // 2. Fetch the conditions from the API and cache it in case
      // we need it again in the future.
      url =
        '/api/services/app/DeviceCondition/GetAll' +
        '?StartDate=' +
        dateRange.start +
        '&EndDate=' +
        dateRange.end
    } else {
      url = '/api/services/app/DeviceCondition/GetAll'
    }
    if (deviceId) {
      url = url + '&DeviceId=' + deviceId
    }
    return axios
      .get(url)
      .then((response) => {
        const conditions = response.data.items
        commit('SET_CACHE', conditions)
        return conditions
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  updateCondition({ commit, dispatch, state, rootState }, { condition }) {
    return axios
      .put('/api/services/app/DeviceCondition/Update', condition)
      .then((response) => {
        dispatch('fetchConditions', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
